type ClarityStub = {
  (...args: unknown[]): void;
  q?: unknown[][];
};

type ClarityGlobal = typeof globalThis & { clarity?: ClarityStub };

function createClarityStub(): ClarityStub {
  const stub: ClarityStub = (...args: unknown[]) => {
    const queue = stub.q ?? [];
    queue.push(args);
    stub.q = queue;
  };
  return stub;
}

/**
 * Inicializa Microsoft Clarity solo si hay project ID en environment.
 * Sin ID configurado, no inyecta scripts ni modifica el runtime.
 */
export function initMicrosoftClarity(projectId: string): void {
  const id = projectId.trim();
  if (!id) {
    return;
  }

  const globalRef = globalThis as ClarityGlobal;
  if (!globalRef.clarity) {
    globalRef.clarity = createClarityStub();
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(id)}`;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
}
